import { CarOutlined, CheckCircleFilled, EnvironmentOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Button, Modal, Space, Typography, Row, Col } from 'antd';
import React from 'react';

const { Text, Title } = Typography;

const ManualTachoModal = ({ open, onOk }) => {
    return (
        <Modal
            open={open}
            onCancel={onOk}
            footer={null}
            centered
            closable={false}
            maskClosable={false}
            width={600}
            styles={{
                body: { padding: 0, overflow: 'hidden', borderRadius: '24px' },
                content: { padding: 0, borderRadius: '24px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }
            }}
        >
            <div style={{
                background: 'linear-gradient(135deg, #0062ff 0%, #0041ab 100%)',
                padding: '24px 32px',
                textAlign: 'left',
                position: 'relative',
                overflow: 'hidden',
                borderTopLeftRadius: '24px',
                borderTopRightRadius: '24px',
                display: 'flex',
                alignItems: 'center',
                gap: '20px'
            }}>
                <div style={{ position: 'absolute', top: '-10%', right: '-5%', width: '100px', height: '100px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)', filter: 'blur(15px)' }} />

                <div style={{
                    display: 'inline-flex',
                    background: 'rgba(255,255,255,0.2)',
                    backdropFilter: 'blur(8px)',
                    padding: '12px',
                    borderRadius: '16px',
                    border: '1px solid rgba(255,255,255,0.3)'
                }}>
                    <InfoCircleFilled style={{ fontSize: '32px', color: '#fff' }} />
                </div>

                <div>
                    <Title level={4} style={{ color: '#fff', margin: 0, fontWeight: 700, letterSpacing: '-0.5px' }}>
                        Manual Tacho Information
                    </Title>
                    <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px', fontWeight: 500 }}>
                        Important Guide for Accurate Recording
                    </Text>
                </div>
            </div>

            <div style={{ padding: '24px 32px', background: '#fff' }}>
                <Row gutter={[20, 20]}>
                    <Col span={24}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            borderRadius: '20px',
                            background: '#f8fbff',
                            border: '1px solid #e1eeff',
                            height: '100%'
                        }}>
                            <div style={{ background: '#0062ff', padding: '10px', borderRadius: '12px' }}>
                                <EnvironmentOutlined style={{ fontSize: '20px', color: '#fff' }} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Text strong style={{ fontSize: '15px', display: 'block', color: '#1a1a1a' }}>Location Access</Text>
                                <Text style={{ fontSize: '13px', color: '#666', lineHeight: '1.3' }}>
                                    Ensure <strong>location services</strong> are enabled on your device.
                                </Text>
                            </div>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            borderRadius: '20px',
                            background: '#f6fff8',
                            border: '1px solid #e6f9ec',
                            height: '100%'
                        }}>
                            <div style={{ background: '#00ca62', padding: '10px', borderRadius: '12px' }}>
                                <CarOutlined style={{ fontSize: '20px', color: '#fff' }} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Text strong style={{ fontSize: '15px', display: 'block', color: '#1a1a1a' }}>Start Drive</Text>
                                <Text style={{ fontSize: '13px', color: '#666', lineHeight: '1.3' }}>
                                    Tap <strong>"Start Drive"</strong> when beginning your route.
                                </Text>
                            </div>
                        </div>
                    </Col>
                </Row>

                <div style={{
                    marginTop: '20px',
                    padding: '12px 16px',
                    borderRadius: '16px',
                    background: '#fafafa',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CheckCircleFilled style={{ color: '#00ca62', fontSize: '16px' }} />
                        <Text type="secondary" style={{ fontSize: '12px', fontWeight: 500 }}>
                            Following these steps ensures your records are accurate.
                        </Text>
                    </div>

                    <Button
                        type="primary"
                        size="middle"
                        onClick={onOk}
                        style={{
                            minWidth: '140px',
                            height: '44px',
                            borderRadius: '12px',
                            fontSize: '15px',
                            fontWeight: 600,
                            background: 'linear-gradient(135deg, #0062ff 0%, #0041ab 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(0, 98, 255, 0.2)'
                        }}
                    >
                        I Understand
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ManualTachoModal;
